import type { TPermission } from "@workspace/domain/src/utils/permissions";
import { t } from "i18next";
import { LucideBriefcase, LucideIdCard, LucideSettings } from "lucide-react";
import * as z from "zod";

export const SettingsTabsSchema = z.object({
  tab: z.enum(["general", "agency", "national-id"]).optional(),
});

export const TABS = [
  {
    id: "general",
    label: t("settings.tabs.general"),
    icon: LucideSettings,
    permission: [] as TPermission[],
  },
  {
    id: "agency",
    label: t("settings.tabs.agency"),
    icon: LucideBriefcase,
    permission: true,
  },
  {
    id: "national-id",
    label: t("settings.tabs.nationalId"),
    icon: LucideIdCard,
    permission: ["nationalId:get"] as TPermission[],
  },
] as const;

export type SettingsTab = (typeof TABS)[number]["id"];
